import { reactive, getCurrentInstance, watch, toRefs } from '@vue/composition-api'
import router from '@/router'
import Vue from 'vue'
// eslint-disable-next-line object-curly-newline
export const EventBus = new Vue()
export const isObject = obj => typeof obj === 'object' && obj !== null

export const isToday = date => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

const getRandomFromArray = array => array[Math.floor(Math.random() * array.length)]

// ? Light and Dark variant is not included
// prettier-ignore
export const getRandomBsVariant = () => getRandomFromArray(['primary', 'secondary', 'success', 'warning', 'danger', 'info'])

export const truncatedDescriptions = items => {
  const limit = 20
  const descriptions = (items || []).map(item => item.description)
  if (descriptions.length <= limit) {
    return descriptions.join(', ')
  }
  const remaining = descriptions.length - limit
  return `${descriptions.slice(0, limit).join(', ')} … and ${remaining} more`
}

// Similar to truncatedDescriptions, but works directly on a plain array of strings
// (e.g. the `descriptions_preview`/`hs_codes_preview` fields returned by the API,
// which are already limited to the first 20 items server-side).
export const truncatedList = list => (list || []).join(', ')

// Resolves a goods shipment's/parcel's total value, preferring the backend-provided
// `value_eur` aggregate (an explicit 0 is a valid total) and falling back to summing
// the embedded `items` array when `value_eur` is absent (null/undefined) — e.g. legacy
// H1 responses that still return the full items array. Returns null when neither is available.
export const resolveGoodsShipmentValue = goodsShipment => {
  if (!goodsShipment) {
    return null
  }
  if (goodsShipment.value_eur != null) {
    return goodsShipment.value_eur
  }
  if (goodsShipment.items && goodsShipment.items.length > 0) {
    return goodsShipment.items.reduce((sum, item) => sum + parseFloat(item.value), 0)
  }
  return null
}

export const isDynamicRouteActive = route => {
  const { route: resolvedRoute } = router.resolve(route)
  return resolvedRoute.path === router.currentRoute.path
}

// Thanks: https://medium.com/better-programming/reactive-vue-routes-with-the-composition-api-18c1abd878d1
export const useRouter = () => {
  const vm = getCurrentInstance().proxy
  const state = reactive({
    route: vm.$route,
  })

  watch(
    () => vm.$route,
    r => {
      state.route = r
    },
  )

  return { ...toRefs(state), router: vm.$router }
}

/**
 * This is just enhancement over Object.extend [Gives deep extend]
 * @param {target} a Object which contains values to be overridden
 * @param {source} b Object which contains values to override
 */
// export const objectExtend = (a, b) => {
//   // Don't touch 'null' or 'undefined' objects.
//   if (a == null || b == null) {
//     return a
//   }

//   Object.keys(b).forEach(key => {
//     if (Object.prototype.toString.call(b[key]) === '[object Object]') {
//       if (Object.prototype.toString.call(a[key]) !== '[object Object]') {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = b[key]
//       } else {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = objectExtend(a[key], b[key])
//       }
//     } else {
//       // eslint-disable-next-line no-param-reassign
//       a[key] = b[key]
//     }
//   })

//   return a
// }
